'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var popper = require('@andes/popper');
var keyboardCodes = require('@andes/common/build/constants/keyboardCodes');
var includes = require('@andes/common/build/utils/includes');
var usePreventScroll = require('@andes/common/build/hooks/usePreventScroll');
var _jsx = require('@babel/runtime/helpers/jsx');
var focus = require('@react-aria/focus');
var common = require('@andes/common');
var CloseIcon16 = require('@andes/icons/Close16');
var SearchIcon16 = require('@andes/icons/Search16');
var CloseIcon20 = require('@andes/icons/Close20');
var SearchIcon20 = require('@andes/icons/Search20');
var Checkbox = require('@andes/checkbox');
var listbox = require('@andes/listbox');
var list = require('@andes/list');
var groupNodeGenerator = require('@andes/list/build/generators/groupNodeGenerator');
var itemNodeGenerator = require('@andes/list/build/generators/itemNodeGenerator');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var includes__default = /*#__PURE__*/_interopDefaultLegacy(includes);
var usePreventScroll__default = /*#__PURE__*/_interopDefaultLegacy(usePreventScroll);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var CloseIcon16__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon16);
var SearchIcon16__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon16);
var CloseIcon20__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon20);
var SearchIcon20__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon20);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);
var groupNodeGenerator__default = /*#__PURE__*/_interopDefaultLegacy(groupNodeGenerator);
var itemNodeGenerator__default = /*#__PURE__*/_interopDefaultLegacy(itemNodeGenerator);
var module$3 = "@andes/floating-menu";
var locale$2 = "en-US";
var translations$2 = {
  "andes-floating-menu\u0004No hay resultados": [null, "No results"],
  "andes-floating-menu\u0004Abrir buscador": [null, "Open search tool"],
  "andes-floating-menu\u0004Buscar": [null, "Search"],
  "andes-floating-menu\u0004Borrar": [null, "Delete search"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/floating-menu";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-floating-menu\u0004No hay resultados": [null, "No hay resultados"],
  "andes-floating-menu\u0004Abrir buscador": [null, "Abrir buscador"],
  "andes-floating-menu\u0004Buscar": [null, "Buscar"],
  "andes-floating-menu\u0004Borrar": [null, "Borrar"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/floating-menu";
var locale = "pt-BR";
var translations = {
  "andes-floating-menu\u0004No hay resultados": [null, "Sem resultados"],
  "andes-floating-menu\u0004Abrir buscador": [null, "Abrir mecanismo de busca"],
  "andes-floating-menu\u0004Buscar": [null, "Procurar"],
  "andes-floating-menu\u0004Borrar": [null, "Excluir"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
const ITEM_DISPLAY_NAME = 'FloatingMenuItem';
const GROUP_DISPLAY_NAME = 'FloatingMenuGroup';
const SUPPORTED_GROUP_TYPES = ['FloatingMenuGroup', 'DropdownGroup'];
const TYPE_MENU = 'menu';
const TYPE_SELECT = 'select';
const SEARCH_BOX_SIZE = 52;
const LIST_ITEM_SIZE = 48;
const listHoverClass = 'andes-floating-menu-item-hover';
const useFloatingMenu = (triggerRef, menuRef, searchBoxRef, componentProps) => {
  const {
    allowUnselect,
    children,
    defaultOpen,
    defaultValue,
    listId,
    menuMaxHeight,
    multiple,
    offset,
    onChange,
    onClose,
    onOpen,
    open,
    popperOptions,
    searchConfig,
    style,
    type,
    value,
    width
  } = componentProps;
  const isGroup = React.useMemo(() => {
    var _firstOption$type;
    if (!children) return false;
    const firstOption = React.Children.toArray(children)[0];
    return includes__default["default"](SUPPORTED_GROUP_TYPES, firstOption === null || firstOption === void 0 || (_firstOption$type = firstOption.type) === null || _firstOption$type === void 0 ? void 0 : _firstOption$type.displayName);
  }, [children]);
  const [currentValues, setCurrentValues] = React.useState(value || defaultValue);
  const [isMenuVisible, setIsMenuVisible] = React.useState(false);
  const [searchItemFocused, setSearchItemFocused] = React.useState(undefined);
  const [searchText, setSearchText] = React.useState(typeof searchConfig === 'object' && (searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.defaultValue));
  usePreventScroll__default["default"]({
    isDisabled: type === TYPE_MENU || type === TYPE_SELECT && !isMenuVisible
  });
  const isUncontrolled = React.useMemo(() => value === undefined, []);
  React.useEffect(() => {
    if (!isUncontrolled) {
      setCurrentValues(value);
    }
  }, [value, isUncontrolled]);
  const isOpenUncontrolled = React.useMemo(() => open === undefined, []);
  const getItemToFocus = menu => {
    const optionsList = Array.prototype.slice.call(menu.querySelectorAll('.andes-list__item'));
    if (optionsList.length) {
      let focusableOption;
      if (type === TYPE_MENU) {
        focusableOption = optionsList[0].querySelector('.andes-list__item-action') || optionsList[0].querySelector('.andes-list__item-anchor');
        if (focusableOption) return focusableOption;
      }
      focusableOption = optionsList.find(option => option.tabIndex === 0);
      if (!focusableOption) {
        focusableOption = optionsList.find(option => option.className.indexOf('andes-list__item--selected') !== -1);
      }
      if (!focusableOption) {
        [focusableOption] = optionsList;
      }
      return focusableOption;
    }
    return null;
  };
  const handleSelectionChange = (event, values) => {
    const shouldAvoidUnselect = !allowUnselect && !multiple && (values === undefined || !(values !== null && values !== void 0 && values.length)) && currentValues !== undefined;
    if (shouldAvoidUnselect) return;
    if (isUncontrolled) setCurrentValues(values);
    let newValue = values;
    if (!multiple && Array.isArray(values)) [newValue] = values;
    if (searchConfig) setSearchItemFocused(state => !Array.isArray(newValue) ? newValue : state);
    if (typeof onChange === 'function') onChange(event, newValue);
  };
  const setPopoverFocus = () => {
    if (searchConfig) {
      var _searchBoxRef$current;
      const label = searchBoxRef === null || searchBoxRef === void 0 || (_searchBoxRef$current = searchBoxRef.current) === null || _searchBoxRef$current === void 0 ? void 0 : _searchBoxRef$current.querySelector('label');
      setTimeout(() => label === null || label === void 0 ? void 0 : label.focus(), 0);
      return;
    }
    const menu = menuRef.current;
    if (menu) {
      const itemToFocus = getItemToFocus(menu);
      if (itemToFocus) {
        itemToFocus.focus();
        menu.scrollTop = itemToFocus.offsetTop - LIST_ITEM_SIZE;
      }
    }
  };
  const onSearchChangeText = text => setSearchText(text);
  const fitsSearchValue = React.useCallback(item => {
    if (!searchText) return true;
    const optionText = item.props.primary || item.props.title;
    if (typeof searchConfig === 'object' && typeof searchConfig.filterCondition === 'function') {
      return searchConfig.filterCondition(searchText, optionText, item);
    }
    return optionText && includes__default["default"](optionText.toLowerCase(), searchText.toLowerCase());
  }, [searchText, typeof searchConfig === 'object' && (searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.filterCondition)]);
  const options = React.useMemo(() => {
    if (!children) return null;
    if (isGroup) {
      let index = 0;
      const groups = [];
      React.Children.forEach(children, (group, groupIndex) => {
        const newChildren = [];
        React.Children.forEach(group === null || group === void 0 ? void 0 : group.props.children, item => {
          if (fitsSearchValue(item)) {
            newChildren.push(/*#__PURE__*/React.cloneElement(item, {
              index,
              groupIndex
            }));
          }
          index += 1;
        });
        if (newChildren.length > 0) {
          groups.push(/*#__PURE__*/React.cloneElement(group, {
            children: newChildren
          }));
        }
      });
      return groups;
    }
    const newChildren = [];
    React.Children.forEach(children, (child, index) => {
      if (fitsSearchValue(child)) {
        newChildren.push(/*#__PURE__*/React.cloneElement(child, {
          index
        }));
      }
    });
    return newChildren;
  }, [children, isGroup, fitsSearchValue]);
  const hoverElement = (list, itemSelected) => {
    const addRemoveFocus = (items, i, index) => {
      if (items[i].classList.contains(listHoverClass)) {
        items[i].classList.remove(listHoverClass);
      }
      if (itemSelected === (index === undefined ? i : index)) {
        items[i].classList.add(listHoverClass);
      }
    };
    if (isGroup) {
      let index = 0;
      for (let j = 0; j < list.length; j += 1) {
        const groupItems = list[j].children[1].children;
        for (let i = 0; i < groupItems.length; i += 1) {
          addRemoveFocus(groupItems, i, index);
          index += 1;
        }
      }
      return;
    }
    for (let i = 0; i < list.length; i += 1) {
      addRemoveFocus(list, i);
    }
  };
  const onSearchFocus = event => {
    setTimeout(() => {
      var _searchBoxRef$current2;
      return (_searchBoxRef$current2 = searchBoxRef.current) === null || _searchBoxRef$current2 === void 0 ? void 0 : _searchBoxRef$current2.focus();
    }, 0);
    const list = isGroup ? options === null || options === void 0 ? void 0 : options.reduce((previousValue, currentValue) => [...previousValue, ...currentValue.props.children], []) : options || [];
    if (!list) return;
    const listLength = list.length;
    setSearchItemFocused(state => {
      var _menuRef$current, _list$focusIndex;
      let index = list.findIndex(_ref => {
        let {
          props
        } = _ref;
        return props.value === state;
      });
      switch (event === null || event === void 0 ? void 0 : event.code) {
        case keyboardCodes.ARROW_DOWN:
          index += 1;
          break;
        case keyboardCodes.ARROW_UP:
          if (index === -1 || index === 0) {
            index = listLength - 1;
            break;
          }
          index -= 1;
          break;
        default:
          index = 0;
          break;
      }
      const focusIndex = index % listLength;
      hoverElement((menuRef === null || menuRef === void 0 || (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.children) || [], focusIndex);
      return (_list$focusIndex = list[focusIndex]) === null || _list$focusIndex === void 0 || (_list$focusIndex = _list$focusIndex.props) === null || _list$focusIndex === void 0 ? void 0 : _list$focusIndex.value;
    });
  };
  const getFocusedItem = () => searchItemFocused;
  React.useEffect(() => {
    if (isMenuVisible && searchConfig && searchItemFocused !== undefined) {
      const menu = menuRef.current;
      if (menu) {
        var _document;
        const itemToScrollTop = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById("".concat(listId, "-option-").concat(searchItemFocused));
        if (itemToScrollTop && menuMaxHeight) {
          const listHeight = menuMaxHeight - SEARCH_BOX_SIZE;
          const itemsToTop = Math.floor(listHeight / LIST_ITEM_SIZE) - 1;
          menu.scrollTop = itemToScrollTop.offsetTop - itemsToTop * LIST_ITEM_SIZE;
        }
      }
    }
  }, [searchConfig, menuRef, searchItemFocused, listId, isMenuVisible]);
  const onSearchSelectionChange = event => {
    if (!searchItemFocused) return;
    if ((multiple || allowUnselect) && Array.isArray(currentValues)) {
      if ((currentValues || []).indexOf(searchItemFocused) > -1) {
        handleSelectionChange(event, currentValues.filter(item => item !== searchItemFocused));
        return;
      }
    }
    if (multiple) {
      handleSelectionChange(event, [...(currentValues || []), searchItemFocused]);
      return;
    }
    handleSelectionChange(event, [searchItemFocused]);
  };
  const resetSearchValues = () => {
    var _searchBoxRef$current3;
    const label = searchBoxRef === null || searchBoxRef === void 0 || (_searchBoxRef$current3 = searchBoxRef.current) === null || _searchBoxRef$current3 === void 0 ? void 0 : _searchBoxRef$current3.querySelector('label');
    if (label !== null && label !== void 0 && label.control) {
      const labelControl = label.control;
      labelControl.value = '';
    }
    setSearchText('');
    if (typeof searchConfig === 'object' && typeof searchConfig.onChange === 'function') searchConfig.onChange('');
  };
  const openMenu = event => {
    setIsMenuVisible(true);
    setTimeout(setPopoverFocus, 0);
    if (typeof onOpen === 'function') onOpen(event);
  };
  const closeMenu = (_, preventFocus) => {
    const trigger = triggerRef.current;
    setIsMenuVisible(false);
    if (searchConfig) resetSearchValues();
    if (trigger && !preventFocus) setTimeout(() => trigger.focus(), 0);
    if (typeof onClose === 'function') onClose();
  };
  const handleClickOutside = _ => {
    closeMenu(_, true);
  };
  const toggleMenu = event => {
    if (isOpenUncontrolled) {
      if (isMenuVisible) {
        closeMenu();
      } else {
        openMenu(event);
      }
      return;
    }
    if (open) {
      if (typeof onClose === 'function') onClose();
    } else if (typeof onOpen === 'function') {
      onOpen(event);
    }
  };
  React.useEffect(() => {
    if (defaultOpen) setTimeout(openMenu, 0);
  }, []);
  React.useEffect(() => {
    if (!isOpenUncontrolled) {
      if (open) {
        setTimeout(openMenu, 0);
      } else if (isMenuVisible) {
        closeMenu();
      }
    }
  }, [open]);
  const getMenuMaxHeightRelatedStyles = () => {
    if (!menuMaxHeight) return {};
    return {
      maxHeight: menuMaxHeight,
      overflowY: 'auto'
    };
  };
  const handleTriggerKeyDown = event => {
    switch (event.code) {
      case keyboardCodes.ESCAPE:
        if (isOpenUncontrolled) {
          closeMenu();
          break;
        }
        if (typeof onClose === 'function') onClose();
        break;
      case keyboardCodes.ARROW_DOWN:
      case keyboardCodes.ARROW_UP:
      case keyboardCodes.ENTER:
      case keyboardCodes.SPACE:
        event.preventDefault();
        if (isOpenUncontrolled) {
          openMenu(event);
          break;
        }
        if (typeof onOpen === 'function') onOpen(event);
        break;
    }
  };
  const getValuesArray = () => {
    if (Array.isArray(currentValues)) return currentValues;
    if (typeof currentValues === 'string' || typeof currentValues === 'number') return [currentValues];
    return [];
  };
  const menuProps = {
    visible: isMenuVisible,
    onSelectionChange: handleSelectionChange,
    options,
    selectedKeys: getValuesArray(),
    style: _objectSpread__default["default"](_objectSpread__default["default"]({}, getMenuMaxHeightRelatedStyles()), {}, {
      width
    }, style),
    popperOptions,
    offset,
    onClickOutside: isOpenUncontrolled ? handleClickOutside : onClose,
    closeMenu: isOpenUncontrolled ? closeMenu : onClose,
    onSearchFocus: searchConfig ? onSearchFocus : undefined,
    onSearchSelectionChange: searchConfig ? onSearchSelectionChange : undefined,
    onSearchChangeText: searchConfig ? onSearchChangeText : undefined,
    getFocusedItem: searchConfig ? getFocusedItem : undefined,
    onMount: searchConfig ? componentProps.onMount : undefined
  };
  const triggerProps = {
    'aria-expanded': isMenuVisible,
    'aria-haspopup': searchConfig || type === 'menu' && !multiple ? 'dialog' : 'listbox',
    onClick: toggleMenu,
    onKeyDown: handleTriggerKeyDown
  };
  return {
    menuProps,
    triggerProps
  };
};
var useFloatingMenu$1 = useFloatingMenu;
const namespace = 'andes-floating-menu';
const namespaceMenuMultiple = "".concat(namespace, "--multiple");
const formNamespace = 'andes-form-control';
const namespaceMenuSearch = "".concat(namespace, "--search");
var _SearchIcon, _SearchIcon2, _CloseIcon, _CloseIcon2;
const SearchBox = /*#__PURE__*/function () {
  const SearchBox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      className,
      defaultValue,
      inputProps = {},
      onChange,
      onClear,
      onKeyDown,
      placeholder,
      size = 'small',
      srLabel,
      value
    } = _ref;
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const inputRef = React.useRef(null);
    const isControlled = React.useMemo(() => typeof value !== 'undefined', []);
    const [focused, setFocused] = React.useState(false);
    const [showClear, setShowClear] = React.useState(false);
    const firstRender = React.useRef(true);
    const {
      device
    } = React.useContext(context.AndesContext);
    const isWebMobileIOS = (device === null || device === void 0 ? void 0 : device.osName) === 'ios';
    React.useEffect(() => {
      if (!isControlled && defaultValue) {
        setShowClear(true);
      }
      firstRender.current = false;
    }, []);
    React.useEffect(() => {
      if (isControlled) {
        const showClearButton = !!value && (value === null || value === void 0 ? void 0 : value.length) > 0;
        setShowClear(showClearButton);
      }
    }, [isControlled, value, setShowClear]);
    React.useEffect(() => {
      if (focused) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
      }
    }, [focused]);
    const SearchIcon = () => {
      if (size === 'small') {
        return _SearchIcon || (_SearchIcon = /*#__PURE__*/_jsx__default["default"](SearchIcon16__default["default"], {}));
      }
      return _SearchIcon2 || (_SearchIcon2 = /*#__PURE__*/_jsx__default["default"](SearchIcon20__default["default"], {}));
    };
    const CloseIcon = () => {
      if (size === 'small') {
        return _CloseIcon || (_CloseIcon = /*#__PURE__*/_jsx__default["default"](CloseIcon16__default["default"], {}));
      }
      return _CloseIcon2 || (_CloseIcon2 = /*#__PURE__*/_jsx__default["default"](CloseIcon20__default["default"], {}));
    };
    const handleChange = event => {
      var _inputRef$current2, _inputRef$current3;
      const showClearButton = !!(inputRef !== null && inputRef !== void 0 && (_inputRef$current2 = inputRef.current) !== null && _inputRef$current2 !== void 0 && _inputRef$current2.value) && (inputRef === null || inputRef === void 0 || (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.value.length) > 0;
      setShowClear(showClearButton);
      if (typeof onChange === 'function') onChange(event);
    };
    const handleClear = event => {
      var _inputRef$current4;
      event.preventDefault();
      if (!isControlled && inputRef.current) inputRef.current.value = '';
      event.target.value = '';
      setShowClear(false);
      if (typeof onClear === 'function') onClear(event);
      if (typeof onChange === 'function') onChange(event);
      (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 || _inputRef$current4.focus();
    };
    const handleBlur = event => {
      const {
        onBlur
      } = inputProps;
      setFocused(false);
      if (typeof onBlur === 'function') onBlur(event);
    };
    const handleFocus = event => {
      const {
        onFocus
      } = inputProps;
      setFocused(true);
      if (typeof onFocus === 'function') onFocus(event);
    };
    const dismissClassNames = classNames__default["default"]("".concat(formNamespace, "__close-icon"), {
      ["".concat(formNamespace, "__close-icon-visible")]: showClear
    });
    const wrapperClassNames = classNames__default["default"](namespaceMenuSearch, "".concat(namespaceMenuSearch, "--size-").concat(size), className, {
      ["".concat(namespaceMenuSearch, "--web-mobile-ios")]: isWebMobileIOS,
      ["".concat(namespaceMenuSearch, "--focused")]: focused,
      ["".concat(namespaceMenuSearch, "--disabled")]: inputProps.disabled
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      ref: ref
    }, /*#__PURE__*/_jsx__default["default"](focus.FocusRing, {
      within: true,
      isTextInput: true,
      focusRingClass: "focus-visible"
    }, void 0, /*#__PURE__*/_jsx__default["default"]("div", {
      className: wrapperClassNames
    }, void 0, /*#__PURE__*/_jsx__default["default"]("label", {}, void 0, /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, srLabel || i18n.pgettext(namespace, 'Buscar')), /*#__PURE__*/React__default["default"].createElement("input", _extends__default["default"]({}, inputProps, {
      className: "".concat(formNamespace, "__field"),
      value: value,
      defaultValue: defaultValue,
      placeholder: placeholder || "".concat(i18n.pgettext(namespace, 'Buscar')),
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      ref: inputRef,
      onKeyDown: onKeyDown
    }))), /*#__PURE__*/_jsx__default["default"]("button", {
      className: dismissClassNames,
      onClick: handleClear,
      onMouseDown: handleClear,
      "aria-label": "".concat(i18n.pgettext(namespace, 'Borrar')),
      type: "button"
    }, void 0, /*#__PURE__*/_jsx__default["default"](CloseIcon, {})), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(formNamespace, "__search-icon")
    }, void 0, /*#__PURE__*/_jsx__default["default"](SearchIcon, {})))));
  });
  SearchBox.displayName = 'SearchBox';
  return SearchBox;
}();
var SearchBox$1 = SearchBox;
const FloatingMenuSearch = /*#__PURE__*/function () {
  const FloatingMenuSearch = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      defaultValue,
      getFocusedItem,
      handleKeyDown,
      list,
      listId,
      onChange,
      placeholder,
      visible
    } = _ref;
    const inputProps = {
      role: 'combobox',
      'aria-label': placeholder,
      'aria-autocomplete': 'list',
      'aria-controls': listId,
      'aria-activedescendant': getFocusedItem() ? "".concat(listId, "-option-").concat(getFocusedItem()) : undefined,
      'aria-expanded': true
    };
    return /*#__PURE__*/_jsx__default["default"]("div", {
      role: "dialog",
      "aria-modal": "true"
    }, void 0, /*#__PURE__*/_jsx__default["default"](focus.FocusScope, {
      contain: visible,
      restoreFocus: true,
      autoFocus: true
    }, void 0, /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__search-box")
    }, void 0, /*#__PURE__*/React__default["default"].createElement(SearchBox$1, {
      ref: ref,
      defaultValue: defaultValue,
      onChange: onChange,
      placeholder: placeholder,
      onKeyDown: handleKeyDown,
      inputProps: inputProps
    })), list));
  });
  FloatingMenuSearch.displayName = 'FloatingMenuSearch';
  return FloatingMenuSearch;
}();
var FloatingMenuSearch$1 = FloatingMenuSearch;
var _Checkbox;
const _excluded$3 = ["children", "className", "defaultValue", "onSelect", "value"];
const FloatingMenuMultiple = /*#__PURE__*/function () {
  const FloatingMenuMultiple = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
        children,
        className,
        defaultValue,
        onSelect,
        value
      } = _ref,
      listProps = _objectWithoutProperties__default["default"](_ref, _excluded$3);
    const [currentValues, setCurrentValues] = React.useState(value || defaultValue);
    const isUncontrolled = React.useMemo(() => value === undefined, []);
    React.useEffect(() => {
      if (!isUncontrolled) {
        setCurrentValues(value);
      }
    }, [value]);
    const customOnSelect = (event, selectedValues, itemDetails) => {
      if (isUncontrolled) setCurrentValues(selectedValues);
      if (typeof onSelect === 'function') onSelect(event, selectedValues, itemDetails);
    };
    const getValuesArray = () => Array.isArray(currentValues) ? currentValues : [];
    const stateProps = {};
    if (!isUncontrolled) {
      stateProps.selectedKeys = getValuesArray();
    } else if (defaultValue) {
      stateProps.defaultSelectedKeys = getValuesArray();
    }
    const floatingMenuMultipleClassNames = classNames__default["default"](namespaceMenuMultiple, className);
    return /*#__PURE__*/React__default["default"].createElement(listbox.ListBox, _extends__default["default"]({
      className: floatingMenuMultipleClassNames,
      selectionComponent: _Checkbox || (_Checkbox = /*#__PURE__*/_jsx__default["default"](Checkbox__default["default"], {
        srHidden: true
      })),
      selectionMode: "multiple",
      ref: ref,
      onSelect: customOnSelect
    }, listProps, stateProps), children);
  });
  FloatingMenuMultiple.displayName = 'FloatingMenuMultiple';
  return FloatingMenuMultiple;
}();
var FloatingMenuMultiple$1 = FloatingMenuMultiple;
const FloatingMenuList = /*#__PURE__*/function () {
  const FloatingMenuList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      i18n,
      id,
      multiple = false,
      onKeyDown,
      onSelect,
      options,
      search = false,
      selectedKeys,
      srLabel,
      type = 'menu',
      visible
    } = _ref;
    if (!options || !options.length) {
      return /*#__PURE__*/_jsx__default["default"]("div", {
        className: "".concat(namespace, "__no-results")
      }, void 0, i18n.pgettext(namespace, 'No hay resultados'));
    }
    const commonProps = {
      id,
      ref,
      className: namespace,
      onKeyDown,
      srLabel
    };
    if (multiple) {
      return /*#__PURE__*/React__default["default"].createElement(FloatingMenuMultiple$1, _extends__default["default"]({}, commonProps, {
        onSelect: onSelect,
        value: selectedKeys,
        shouldUseVirtualFocus: !!search
      }), options);
    }
    if (type === 'select' || search) {
      return /*#__PURE__*/React__default["default"].createElement(listbox.ListBox, _extends__default["default"]({}, commonProps, {
        onSelect: onSelect,
        selectionMode: multiple ? 'multiple' : 'single',
        selectedKeys: selectedKeys,
        shouldUseVirtualFocus: !!search
      }), options);
    }
    const handleMenuClick = (childOnSelect, event, value) => {
      if (typeof childOnSelect === 'function') childOnSelect(event, value);
      if (typeof onSelect === 'function') onSelect(event, value);
    };
    const getItem = item => /*#__PURE__*/React.cloneElement(item, {
      onClick: (evt, value) => handleMenuClick(item.props.onClick, evt, value),
      tabIndex: undefined
    });
    return /*#__PURE__*/_jsx__default["default"]("div", {
      role: "dialog",
      "aria-modal": "true"
    }, void 0, /*#__PURE__*/_jsx__default["default"](focus.FocusScope, {
      contain: visible,
      restoreFocus: true,
      autoFocus: true
    }, void 0, /*#__PURE__*/React__default["default"].createElement(list.List, commonProps, React__default["default"].Children.map(options, child => {
      var _child$type;
      const isGroup = (child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === GROUP_DISPLAY_NAME;
      if (isGroup) {
        const items = React__default["default"].Children.map(child.props.children, getItem);
        return /*#__PURE__*/React.cloneElement(child, {
          children: items
        });
      }
      return getItem(child);
    }))));
  });
  FloatingMenuList.displayName = 'FloatingMenuList';
  return FloatingMenuList;
}();
var FloatingMenuList$1 = FloatingMenuList;
const computeSearchProps = _ref => {
  let {
    search: searchProps,
    defaultSearchValue: defaultSearchValueProp,
    filterCondition: filterConditionProp,
    onSearchChange: onSearchChangeProp,
    searchPlaceholder: searchPlaceholderProp
  } = _ref;
  if (!searchProps) return undefined;
  if (typeof searchProps === 'boolean') {
    return {
      defaultValue: defaultSearchValueProp,
      placeholder: searchPlaceholderProp,
      onChange: onSearchChangeProp,
      filterCondition: filterConditionProp,
      search: true
    };
  }
  const {
    defaultValue: defaultValueConfig,
    filterCondition: filterConditionConfig,
    onChange: onChangeConfig,
    placeholder: placeholderConfig
  } = searchProps;
  return {
    defaultValue: defaultValueConfig || defaultSearchValueProp,
    placeholder: placeholderConfig || searchPlaceholderProp,
    onChange: onChangeConfig || onSearchChangeProp,
    filterCondition: filterConditionConfig || filterConditionProp,
    search: true
  };
};
var computeSearchProps$1 = computeSearchProps;
const _excluded$2 = ["closeMenu", "getFocusedItem", "onSearchChangeText", "onSearchFocus", "onSearchSelectionChange", "onSelectionChange", "options", "selectedKeys"];
const FloatingMenu = /*#__PURE__*/function () {
  const FloatingMenu = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
      allowUnselect = false,
      appendTo,
      'aria-label': _willdeprecate$ariaLabel,
      className,
      closable: _wildeprecate$closable,
      defaultOpen = false,
      defaultSearchValue: _willdeprecate$defaultSearchValue,
      filterCondition: _willdeprecate$filterCondition,
      id,
      menuMaxHeight,
      multiple = false,
      onSearchChange: _willdeprecate$onSearchChange,
      placement = 'bottom',
      search = false,
      searchPlaceholder: _willdeprecate$searchPlaceholder,
      srLabel,
      trigger,
      type = 'menu',
      width = 280
    } = props;
    const componentId = context.useId(id);
    const searchConfig = computeSearchProps$1({
      search,
      defaultSearchValue: _willdeprecate$defaultSearchValue,
      onSearchChange: _willdeprecate$onSearchChange,
      searchPlaceholder: _willdeprecate$searchPlaceholder,
      filterCondition: _willdeprecate$filterCondition
    });
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const listId = "".concat(componentId, "-list");
    const triggerRef = React.useRef(null);
    const menuRef = React.useRef(null);
    const searchBoxRef = React.useRef(null);
    const hasSearched = React.useRef(false);
    const {
      menuProps,
      triggerProps
    } = useFloatingMenu$1(triggerRef, menuRef, searchBoxRef, _objectSpread__default["default"](_objectSpread__default["default"]({}, props), {}, {
      allowUnselect,
      defaultOpen,
      multiple,
      placement,
      search,
      type,
      width,
      listId,
      id: componentId,
      searchConfig
    }));
    const {
        closeMenu,
        getFocusedItem,
        onSearchChangeText,
        onSearchFocus,
        onSearchSelectionChange,
        onSelectionChange,
        options,
        selectedKeys
      } = menuProps,
      otherMenuProps = _objectWithoutProperties__default["default"](menuProps, _excluded$2);
    React.useEffect(() => {
      if (hasSearched.current) {
        hasSearched.current = false;
        if (typeof onSearchFocus === 'function') onSearchFocus();
      }
    }, [hasSearched.current]);
    React.useEffect(() => {
      const menu = menuRef.current;
      if (menu && searchConfig) {
        requestAnimationFrame(() => {
          menu.style.maxHeight = menuMaxHeight ? "".concat(menuMaxHeight - SEARCH_BOX_SIZE, "px") : '';
          menu.style.overflowY = 'auto';
        });
      }
    }, [menuRef.current, menuMaxHeight, searchConfig]);
    const handleSelectionChange = (event, values) => {
      if (values) {
        onSelectionChange(event, values);
      } else {
        onSearchSelectionChange(event);
      }
      if (!multiple && _wildeprecate$closable !== false && typeof closeMenu === 'function') closeMenu();
    };
    const handleKeyDown = event => {
      switch (event.code) {
        case keyboardCodes.TAB:
          if (type !== 'menu') event.preventDefault();
          break;
        case keyboardCodes.ESCAPE:
          if (typeof closeMenu === 'function') closeMenu();
          break;
        case keyboardCodes.ARROW_UP:
        case keyboardCodes.ARROW_DOWN:
          if (searchConfig) onSearchFocus(event);
          break;
        case keyboardCodes.ENTER:
          if (searchConfig) handleSelectionChange(event);
          break;
      }
    };
    const handleSearchChange = event => {
      const {
        value
      } = event.target;
      hasSearched.current = true;
      if (typeof onSearchChangeText === 'function') onSearchChangeText(value);
      if (typeof (searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.onChange) === 'function') searchConfig.onChange(value);
    };
    const getContent = () => {
      const list = /*#__PURE__*/React__default["default"].createElement(FloatingMenuList$1, {
        id: listId,
        multiple: multiple,
        onKeyDown: handleKeyDown,
        onSelect: handleSelectionChange,
        options: options,
        ref: menuRef,
        selectedKeys: selectedKeys,
        type: type,
        search: searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.search,
        srLabel: srLabel || _willdeprecate$ariaLabel,
        visible: menuProps.visible,
        i18n: i18n
      });
      if (!searchConfig) return list;
      return /*#__PURE__*/React__default["default"].createElement(FloatingMenuSearch$1, _extends__default["default"]({
        getFocusedItem: getFocusedItem,
        handleKeyDown: handleKeyDown,
        list: list,
        listId: listId,
        ref: searchBoxRef,
        visible: menuProps.visible
      }, searchConfig, {
        onChange: handleSearchChange
      }));
    };
    const containerClassNames = classNames__default["default"](namespace, className, {
      ["".concat(namespace, "--multiple")]: multiple
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: containerClassNames,
      ref: ref
    }, /*#__PURE__*/React__default["default"].createElement(popper.Popper, _extends__default["default"]({
      appendTo: appendTo,
      content: getContent(),
      interactive: true,
      placement: placement,
      id: "".concat(componentId, "-popper"),
      focusScope: true
    }, otherMenuProps), /*#__PURE__*/React.cloneElement(trigger, _objectSpread__default["default"]({
      ref: triggerRef
    }, triggerProps))));
  });
  FloatingMenu.displayName = 'FloatingMenu';
  return FloatingMenu;
}();
var FloatingMenu$1 = FloatingMenu;
const _excluded$1 = ["children"];
const FloatingMenuGroup = /*#__PURE__*/function () {
  const FloatingMenuGroup = _ref => {
    let {
        children
      } = _ref,
      props = _objectWithoutProperties__default["default"](_ref, _excluded$1);
    return /*#__PURE__*/React__default["default"].createElement(list.ListGroup, props, children);
  };
  FloatingMenuGroup.getCollectionNode = groupNodeGenerator__default["default"];
  FloatingMenuGroup.displayName = GROUP_DISPLAY_NAME;
  return FloatingMenuGroup;
}();
var FloatingMenuGroup$1 = FloatingMenuGroup;
const _excluded = ["description", "disabled", "groupIndex", "index", "onSelect", "primary", "rightContent", "secondary", "selected", "tertiary", "title", "value"];
const FloatingMenuItem = /*#__PURE__*/function () {
  const FloatingMenuItem = _ref => {
    let {
        description,
        disabled = false,
        groupIndex,
        index,
        onSelect,
        primary: _willdeprecate$primary,
        rightContent,
        secondary: _willdeprecate$secondary,
        selected = false,
        tertiary: _willdeprecate$tertiary,
        title,
        value
      } = _ref,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);
    const handleSelect = (event, selection) => {
      if (typeof selection === 'object') {
        onSelect(event, selection === null || selection === void 0 ? void 0 : selection.value);
        return;
      }
      onSelect(event, selection);
    };
    const itemProps = _objectSpread__default["default"]({
      index,
      groupIndex,
      disabled,
      title: title || _willdeprecate$primary,
      description: description || _willdeprecate$secondary,
      rightContent: rightContent || _willdeprecate$tertiary,
      value,
      selected
    }, props);
    const onClickHandler = e => {
      if (!disabled) {
        if (typeof itemProps.onClick === 'function') itemProps.onClick(e, value);
        if (typeof onSelect === 'function') {
          handleSelect(e, {
            value
          });
        }
      }
    };
    return /*#__PURE__*/React__default["default"].createElement(list.ListItem, _extends__default["default"]({}, itemProps, {
      onClick: onClickHandler
    }));
  };
  FloatingMenuItem.getCollectionNode = itemNodeGenerator__default["default"];
  FloatingMenuItem.displayName = ITEM_DISPLAY_NAME;
  return FloatingMenuItem;
}();
var FloatingMenuItem$1 = FloatingMenuItem;
exports.FloatingMenu = FloatingMenu$1;
exports.FloatingMenuGroup = FloatingMenuGroup$1;
exports.FloatingMenuItem = FloatingMenuItem$1;
exports["default"] = FloatingMenu$1;
